import { Injectable } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import { ProgressLoaderAssurantService } from './progress-loader-assurant.service';
import { ProgressLoaderService } from './progress-loader.service';
import { AppConstants } from 'src/app/core/constants';



// Will handle the loaders behaviours
@Injectable({
  providedIn: 'root'
})
export class LoaderManagerService {
  // Add Any API Endpoints that needs UI to be blocked
  private BlockingAPIRequest = ['/contractswithmembers',
                                `/${AppConstants.API_ENDPOINTS.PortalProfile}`,
                                '/paymentprofile',
                                '/changepassword',
                                '/gsspauthtoken',
                                '/graphql',
                                '/forgotpassword'
                                ];


  private totalBlockingRequests = 0;
  private totalClassicRequests = 0;

  // Local configuration if exceptions needed
  //
  // You can filter the http requests that won't trigger any loader to
  // show by providing an array of regex patterns or specific word contained ine the Url (and params):
  // like '\\d', '[a-zA-Z]' or 'resource', 'signingUrl', ...
// tslint:disable-next-line: variable-name
  private _filteredUrlPatterns: string[] = ['initSession'];

  // You can filter the http requests by providing an array of HTTP methods (case insensitive):
  // like 'gEt', 'POST', 'Put', 'options', ...
// tslint:disable-next-line: variable-name
  private _filteredMethods: string[] = [];

  // You can also filter the http requests by providing an array of HTTP headers Name (doesn't work for a Header Value) (case insensitive):
  // tslint:disable-next-line: variable-name
  private _filteredHeaders: string[] = ['lazy'];

  // if you just don't want to show any loader at all, probably for tests/debugging purpose
  // tslint:disable-next-line: variable-name
  private _forceByPass = false;

  private isGlobalFeatureBlockUILoaaderEnabled=false;
  constructor(
    public classicLoaderService: ProgressLoaderService, // classicLoader
    public blockingLoaderService: ProgressLoaderAssurantService
  ) {
    this.isGlobalFeatureBlockUILoaaderEnabled= true;
  }

  // Wether the request will block the UI or not
  private shouldRequestBlockUI(request: HttpRequest<any>): boolean {
    // console.log("Loader Request:" + request.url + "-" +  request.headers.has(RequestCriticalLevel.Low));
    //return request.headers.has(RequestCriticalLevel.Critical);
    for(const str of this.BlockingAPIRequest) {
      if(request.url.indexOf(str)>-1) {
        return true;
      }
    }
    return false;
  }

  // manage Loaders when request starts
  onRequestStart(request: HttpRequest<any>) {
    const shoulByPass = this.shouldBypass(request);
    if (!shoulByPass) {
      if (this.isGlobalFeatureBlockUILoaaderEnabled && this.shouldRequestBlockUI(request)) {
        this.startBlockingLoader();
      } else {
        this.startClassicLoader();
      }
    }
  }

  private startBlockingLoader() {
    this.totalBlockingRequests++;
    // force hide the classic one in case it's running.
    this.classicLoaderService.hide();
    this.blockingLoaderService.show();
  }

  private startClassicLoader() {
    this.totalClassicRequests++;
    // show this loader if only the blocking one is not running
    if (this.totalBlockingRequests === 0) {
      this.classicLoaderService.show();
    }
  }

  //#endregion

  //#region Managing STOP Behaviour

  // manage Loaders when request stops
  onRequestStop(request: HttpRequest<any>) {
    if (this.isGlobalFeatureBlockUILoaaderEnabled && this.shouldRequestBlockUI(request)) {
      this.stopBlockingLoader();
    } else {
      this.stopClassicLoader();
    }
  }

  private stopBlockingLoader() {
    // prevent blocking requests number < 0, should not be possible but let's add some firewall.
    if (this.totalBlockingRequests > 0) {
      this.totalBlockingRequests--;
    }
    // if there isn't blocking requests running, hide the blocking loader
    if (this.totalBlockingRequests === 0) {
      this.blockingLoaderService.hide();
      // if there is classic requests running, let's show the classic loader
      if (this.totalClassicRequests > 0) {
        this.classicLoaderService.show();
      }
    }
  }

  private stopClassicLoader() {
    // prevent classic requests number < 0, should not be possible but let's add some firewall.
    if (this.totalClassicRequests > 0) {
      this.totalClassicRequests--;
    }
    // if there isn't classic requests running, hide the classic loader
    if (this.totalClassicRequests === 0) {
      this.classicLoaderService.hide();
    }
  }

  //#endregion

  //#region ByPass

  private shouldBypassUrl(url: string): boolean {
    return this._filteredUrlPatterns.some(e => {
      let reg = new RegExp(e);
      return reg.test(url);
    });
  }

  private shouldBypassMethod(req: HttpRequest<any>): boolean {
    return this._filteredMethods.some(e => {
      return e.toUpperCase() === req.method.toUpperCase();
    });
  }

  private shouldBypassHeader(req: HttpRequest<any>): boolean {
    return this._filteredHeaders.some(e => {
      return req.headers.has(e);
    });
  }

  private shouldBypass(req: HttpRequest<any>): boolean {
    return (
      this.shouldBypassUrl(req.urlWithParams) ||
      this.shouldBypassMethod(req) ||
      this.shouldBypassHeader(req) ||
      this._forceByPass
    );
  }

  //#endregion
}
